var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0338 1H9.05588M1.01172 3H13.078M11.7373 3L11.2672 10.0129C11.1966 11.065 11.1614 11.5911 10.9329 11.99C10.7317 12.3412 10.4282 12.6235 10.0625 12.7998C9.64711 13 9.11695 13 8.05663 13H6.03306C4.97274 13 4.44258 13 4.02717 12.7998C3.66144 12.6235 3.35799 12.3412 3.15682 11.99C2.92832 11.5911 2.89305 11.065 2.82252 10.0129L2.35241 3M5.70415 6V9.33333M8.38554 6V9.33333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.747046dac77c3d0ec55e5d85d7b32201.svg";
export { ForwardRef as ReactComponent };